"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button = ({ type }) => {
    return (react_1.default.createElement("button", { className: "DateRangePickerInput_calendarIcon DateRangePickerInput_calendarIcon_1", type: "button", "aria-label": "Interact with the calendar and add the check-in date for your trip.", style: type === 'calendar' ? { top: 'calc(50% - 11px)' } : {} },
        react_1.default.createElement("i", { className: "material-icons notranslate" }, "\uE24F")));
};
exports.default = Button;
//# sourceMappingURL=Button.js.map